import { Textarea } from "@/components/ui/textarea";
import { cn } from "@/lib/utils";

interface TextInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  maxChars: number;
  disabled?: boolean;
  label?: string;
}

export function TextInput({
  value,
  onChange,
  placeholder,
  maxChars,
  disabled,
  label,
}: TextInputProps) {
  const remaining = maxChars - value.length;
  const isOver = remaining < 0;

  return (
    <div className="space-y-1.5">
      {label && (
        <label className="text-sm font-medium text-muted-foreground">
          {label}
        </label>
      )}
      <Textarea
        value={value}
        onChange={(e) => {
          if (e.target.value.length <= maxChars) {
            onChange(e.target.value);
          }
        }}
        placeholder={placeholder}
        disabled={disabled}
        rows={3}
        className="resize-none"
      />
      <div
        className={cn(
          "text-right text-xs",
          isOver ? "text-destructive" : "text-muted-foreground",
        )}
      >
        {value.length}/{maxChars}
      </div>
    </div>
  );
}
